import * as React from 'react';
import { Button, Modal, ModalVariant } from '@patternfly/react-core';
import { IIdleTimer } from 'react-idle-timer';

interface IdleWarningModalProps {
    isOpen: boolean;
    idleTimer: IIdleTimer;
    onUserInteraction: () => void;
    onLogOut: () => void;
}

const IdleWarningModal: React.FC<IdleWarningModalProps> = ({ isOpen, onUserInteraction, onLogOut, idleTimer }) => {
    const [timeRemaining, setTimeRemaining] = React.useState(idleTimer.getRemainingTime());

    React.useEffect(
        () => {
            let mounted = true;
            if (mounted && isOpen) {
                setTimeRemaining(idleTimer.getRemainingTime());
            }

            return () => {
                mounted = false;
            };
        },
        [isOpen]
    );

    const interval = setInterval(
        () => {setTimeRemaining(idleTimer.getRemainingTime())},
        1000
    );

    const millisecondsToSeconds = (milliseconds: number) => {
        if (milliseconds <= 0) {
            return 0;
        }

        return Math.floor(milliseconds/1000);
    };

    if (millisecondsToSeconds(timeRemaining) === 0) {
        clearInterval(interval);
    }

    return <Modal 
        title="Are you still here?"
        isOpen={isOpen}
        showClose={false}
        onClose={onUserInteraction}
        variant={ModalVariant.small}
        actions={[
            <Button key="userStillHere" variant="primary" onClick={onUserInteraction}>
                Keep Me Logged In
            </Button>,
            <Button key="cancel" variant="link" onClick={onLogOut} style={{marginBottom: '20px'}}>
                Log Out
            </Button>
        ]}
    >
        Remain logged in by clicking the button below, otherwise you'll automatically be logged out in {millisecondsToSeconds(timeRemaining)} seconds.
    </Modal>
};

export default IdleWarningModal;